import { nullable, object, optional, type InferOutput } from "valibot"
import { StoredItemMetaUnionSchema } from "../../../core/Storage/StoredItem/StoredItemMetaUnion.type"

export const InputProfileMetaSchema = object({
  selected: optional(nullable(StoredItemMetaUnionSchema)),
})

export type InputProfileMeta = InferOutput<typeof InputProfileMetaSchema>

